import { HistoryPanelContractJoinersDocument } from 'generated/resources/graphql'

import { useLazyQuery } from 'modules/core/hooks/useQuery'

type FetchJoinersParams = {
  employeeIds: number[]
  startDate: string
  endDate: string
  itemsPerPage: number
  lastCursor?: string
}

export const useJoiners = () => {
  const [fetchJoiners, { data, loading, error }] = useLazyQuery(HistoryPanelContractJoinersDocument)

  const fetch = ({
    employeeIds,
    startDate,
    endDate,
    itemsPerPage,
    lastCursor,
  }: FetchJoinersParams) => {
    fetchJoiners({
      variables: {
        employeeIds,
        startDate,
        endDate,
        itemsPerPage,
        after: lastCursor,
      },
    })
  }

  return {
    fetch,
    data,
    loading,
    error,
  }
}
